import React, { createContext, useContext, useState, ReactNode } from "react";

interface DynamicMenuActionContextProps {
  dynamicMenuAction: any; // Replace `any` with the appropriate type
  setDynamicMenuAction: (data: any) => void; // Replace `any` with the appropriate type
}

const DynamicMenuActionContext = createContext<DynamicMenuActionContextProps | undefined>(undefined);

export const DynamicMenuActionProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [dynamicMenuAction, setDynamicMenuAction] = useState<any>(null);  

  return (
    <DynamicMenuActionContext.Provider value={{ dynamicMenuAction, setDynamicMenuAction }}>
      {children}
    </DynamicMenuActionContext.Provider>
  );
};

export const useDynamicMenuAction = () => {
  const context = useContext(DynamicMenuActionContext);
  if (!context) {
    throw new Error("useDynamicMenuAction must be used within a DynamicMenuActionProvider");
  }
  return context;
};
